import { useEffect, useState, lazy, Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadTranslations, selectLang } from "../features/lang/langSlice";

const LoadingScreen = lazy(() => import("../common/components/LoadingScreen"));
const AppRoutes = lazy(() => import("./AppRoutes"));

const App = () => {
  const dispatch = useDispatch();
  const lang = useSelector(selectLang);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadLang = async () => {
      const htmlElement = document.documentElement;
      htmlElement.setAttribute("lang", lang);
      await dispatch(loadTranslations(lang));
      setLoading(false);
    };

    loadLang();
  }, [dispatch, lang]);

  if (!loading) {
    return (
      <Suspense fallback={null}>
        <AppRoutes />
      </Suspense>
    );
  }

  return (
    <Suspense fallback={null}>
      <LoadingScreen />
    </Suspense>
  );
};

export default App;
